import { action, makeObservable, observable, computed } from 'mobx';

export interface ElementSizeType {
    width: number;
    height: number;
}

export class RaceCardHeaderState {
    @observable public isExpanded = false;
    @observable public articleRef: HTMLDivElement | null = null;
    @observable public articleSize: ElementSizeType | null = null;

    private resizeObserver: ResizeObserver | null = null;

    public constructor() {
        makeObservable(this);
    }

    @computed public get showExpandCollapseButton(): boolean {
        const ref = this.articleRef;
        const size = this.articleSize;

        if (ref !== null && size !== null) {
            const lineHeightStr = getComputedStyle(ref).lineHeight;
            const lineHeight = isNaN(parseFloat(lineHeightStr)) ? 16 : parseFloat(lineHeightStr);

            if (this.isExpanded) {
                const lines = ref.scrollHeight / lineHeight;
                return lines > 1;
            }

            return ref.scrollHeight > Math.round(size.height) || ref.scrollWidth > Math.round(size.width);
        }
        return false;
    }

    @action public handleExpanded = (): void => {
        this.isExpanded = !this.isExpanded;
    };

    @action public setArticleRef = (ref: HTMLDivElement | null): void => {
        this.disconnect();
        this.articleRef = ref;

        if (ref === null) {
            return;
        }

        this.resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                this.setArticleSize({ width, height });
            }
        });

        this.resizeObserver.observe(ref);

        this.setArticleSize({
            width: ref.offsetWidth,
            height: ref.offsetHeight,
        });
    };

    @action private setArticleSize = (size: ElementSizeType): void => {
        this.articleSize = size;
    };

    private disconnect(): void {
        if (this.resizeObserver !== null) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
}
